import * as R from 'ramda';
import React from 'react';
import { FeatureFlag } from 'react-launch-darkly';

const getTruncatedEmail = user =>
    R.lt(R.length(user.email.length), 18) ? user.email : `${R.slice(0, 18, user.email)}...`;

const SalesDetailsV1 = ({campaignRoles, campaign, salesDetails}) => {
    const {account_manager_user_id, sales_rep_user_id, external_salesforce_opportunity_id = 'N/A'} = salesDetails;
    const {io_signed, guidelines_approved_by_user_id} = campaign;

    const accountManager = R.find(R.propEq('id', account_manager_user_id))(campaignRoles.accountManagers);
    const salesRep = R.find(R.propEq('id', sales_rep_user_id))(campaignRoles.salesReps);
    const guidelinesApprover = R.find(R.propEq('id', guidelines_approved_by_user_id))(campaignRoles.accountManagers);

    return (
        <div className="sales-details">
            <div className="section-title section-title--sales-details">Sales Details</div>
            <div className="sales-details-grid">
                <div className="sales-detail">
                    <div className="section-details-title">Account Manager</div>
                    <div className="section-details-value">
                        {accountManager ? getTruncatedEmail(accountManager) : 'N/A'}
                    </div>
                </div>
                <div className="sales-detail">
                    <div className="section-details-title">Sales Representative</div>
                    <div className="section-details-value">{salesRep ? getTruncatedEmail(salesRep) : 'N/A'}</div>
                </div>
                <div className="sales-detail">
                    <div className="section-details-title">Salesforce ID</div>
                    <div className="section-details-value">{external_salesforce_opportunity_id}</div>
                </div>
                <div className="sales-detail">
                    <div className="section-details-title">Guidelines Approved By</div>
                    <div className="section-details-value">
                        {guidelinesApprover ? getTruncatedEmail(guidelinesApprover) : 'N/A'}
                    </div>
                </div>
                <div className="sales-detail">
                    <div className="section-details-title">Signed IO</div>
                    <div className="section-details-value">{io_signed === 1 ? 'Yes' : 'No'}</div>
                </div>
            </div>
        </div>
    );
};


// SalesDetailsV2 component New version of the RTL page
const SalesDetailsV2 = ({campaignRoles, salesDetails}) => {
    const {account_manager_user_id, external_salesforce_opportunity_id = 'N/A'} = salesDetails;

    const accountManager = R.find(R.propEq('id', account_manager_user_id))(campaignRoles.accountManagers);

    return (
        <div className="sales-section">
            <div>
                <p className="content-section-title">Account Manager</p>
                <p>
                    <i className="fa fa-user fa-lg" style={{ marginRight: '6px' }} />
                    {accountManager ? getTruncatedEmail(accountManager) : 'N/A'}
                </p>
            </div>
            <span className="content-separator"></span>
            <div>
                <p className="content-section-title">Salesforce ID</p>
                <p>{external_salesforce_opportunity_id}</p>
            </div>
        </div>
    );
};


const SalesDetails = (props) => (
    <FeatureFlag
        flagKey="order-form-v2-enabled"
        renderFeatureCallback={flag =>
            flag
                ? <SalesDetailsV2 {...props} />
                : <SalesDetailsV1 {...props} />
        }
        renderDefaultCallback={() => <SalesDetailsV1 {...props} />}
    />
);

export default SalesDetails;


// WEBPACK FOOTER //
// ./components/verify_receipt_common/sales_details.js